import { render, staticRenderFns } from "./GraphDetail05.vue?vue&type=template&id=6ff81531&scoped=true"
import script from "./GraphDetail05.vue?vue&type=script&lang=js"
export * from "./GraphDetail05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff81531",
  null
  
)

export default component.exports